import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import { Link, useNavigate } from "react-router-dom";
import { HEADERS_API } from "./NuevaGuia";
import { useState, useEffect, useSyncExternalStore } from "react";
import axios from "axios";
import { mostrarAviso} from "./components/Aviso";
import Aviso from "./components/Aviso";
import { ValidarSesion } from "../shared/Validaciones";
import { ValidarNum, ValidarNumLtr } from "../shared/Regex";

export default function NuevoTransportista(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const[nroDoc, setNroDoc] = useState("");
    const[razSoc, setRazSoc] = useState("");
    const[registroMTC, setRegistroMTC] = useState("");
    //ESTADOS DE CONTENIDO
    const[indicadorConsultaSunat, setIndicadorSunat] = useState(0);
    //ESTADOS DE VALIDACIÓN
    const[datosCompletos, setDatosCompletos] = useState(false);
    //#endregion

    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
    },[]);

    // VALIDAR QUE LOS DATOS ESTÉN COMPLETOS
    useEffect(()=>{
        try{
            if(nroDoc == "" || razSoc == ""){
                throw new Error();
            }
            if(nroDoc.length != 11){
                throw new Error();
            }

            HandlerDatosCompletos(true);
        }catch(error){
            HandlerDatosCompletos(false);
        }
    },[nroDoc, razSoc]);
    //#endregion

    // ======================================================================================================
    //#region  HOOK NAVIGATE
    // ======================================================================================================
    const navigate = useNavigate();
    //#endregion


    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const HandlerNroDoc = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setNroDoc(valor);
        }
    }
    const HandlerRegistroMTC = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setRegistroMTC(valor.toUpperCase());
        }
    }

    const HandlerRazSoc = (valor) => setRazSoc(valor.toUpperCase());
    
    //ESTADOS DE CONTENIDO
    const HandlerIndicadorConsultaSunat = (valor) => setIndicadorSunat(valor);
    //ESTADOS DE VALIDACIÓN
    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    
    //#endregion

    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    async function ConsultaRucSunat(){
        try{
            //Vaciar valores y mostrar spinner de carga
            HandlerIndicadorConsultaSunat(1);

            const response = await axios.get(URL_CONSULTA_RUC_SUNAT, {
                headers: HEADERS_API,
                params:{
                    ruc: nroDoc
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            if(response.data.mensajeError != null){
                throw new Error(response.data.mensajeError);
            }

            HandlerIndicadorConsultaSunat(0);
            HandlerRazSoc(response.data.nombre);

        }catch(error){
            console.log(error.message);
            HandlerIndicadorConsultaSunat(0);
        }
    }
    async function ConsultarDatos(){
        if(nroDoc.length == 11){
            ConsultaRucSunat();
        }else{
            mostrarAviso("Ingrese un número de documento válido");
        }
    }
    const registrarTransportista = async () =>{
        try{
            let response = await axios.post(URL_INSERTAR_TRANSPORTISTA,{
                codigoUsuario: "",
                ruc: nroDoc,
                razSoc: razSoc,
                registroMTC: registroMTC
            },{
                headers:HEADERS_API
            }).catch(error=>{
                throw new Error(error.response.data);
            });
            navigate("/transportistas");
        }catch(error){
            mostrarAviso(error, 2500);
        }
    }
    // FUNCIONES COMPLEMENTARIAS

    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <Aviso/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className='col-12 p-3 text-secondary'>
                <Link className='' to={'/transportistas'}>
                    <button className='btn btn-secondary'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-return-left" 
                        viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"/>
                        </svg>
                        <span className='mx-2'>Regresar</span>
                    </button>
                </Link>
            </div> 
            <div className='col-12 pb-2 fs-3 fw-semibold'>
                NUEVO TRANSPORTISTA
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="nro-documento">N° RUC</label>
                    <div className="input-group mb-3">
                        <input onChange={e=>HandlerNroDoc(e.target.value)} value={nroDoc} maxLength={11} type="text" className="form-control" id="nro-documento" autoComplete="off"/>
                        <button onClick={ConsultarDatos} disabled={indicadorConsultaSunat == 1} className="btn btn-primary" type="button"> 
                            {
                                indicadorConsultaSunat == 1 ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-three-dots" viewBox="0 0 16 16">
                                        <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/>
                                    </svg>
                                ) : (                           
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                                    </svg>
                                )
                            }
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="razon-social">Razón Social</label>
                    <input onChange={e=>HandlerRazSoc(e.target.value)} value={razSoc} maxLength={120} type="text" className="form-control" />
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="registro-mtc">Registro MTC (opcional)</label>
                    <input onChange={e=>HandlerRegistroMTC(e.target.value)} value={registroMTC} maxLength={20} type="text" className="form-control" />
                </div>
            </div>
            <div className="col-12 py-3 d-flex justify-content-center align-items-center">
                <button onClick={registrarTransportista} disabled={!datosCompletos} className="btn btn-primary">Registrar Transportista</button>
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_CONSULTA_RUC_SUNAT = process.env.REACT_APP_URL_CONSULTA_RUC_SUNAT;
const URL_INSERTAR_TRANSPORTISTA = process.env.REACT_APP_URL_INSERTAR_TRANSPORTISTA;
//#endregion